import {
  type MoveRunToGroupMutation,
  type MoveRunToGroupMutationVariables,
} from '../../../generated/graphql';
import {useMutation} from '../../../state/graphql/apolloWithAbort';
import {useAsyncBatcher} from '../../../util/hooks/useAsyncBatcher';
import {MOVE_RUN_TO_GROUP} from './MoveRunToGroupMutation.query';

export type RunToMove = {id: string};
type UseRunMoverHook = ReturnType<typeof useAsyncBatcher<RunToMove, unknown>>;

type UseRunMoverOpts = {
  groupName: string | null;
  entityName: string;
  projectName: string;
};

/**
 * Moves one or more runs between groups in the run selector. This uses
 * useAsyncBatcher under the hood to batch up HTTP requests.
 *
 * @param groupName
 * @param entityName
 * @param projectName
 */
export function useRunMover({
  groupName,
  entityName,
  projectName,
}: UseRunMoverOpts): UseRunMoverHook {
  const [moveRunMutation] = useMutation<
    MoveRunToGroupMutation,
    MoveRunToGroupMutationVariables
  >(MOVE_RUN_TO_GROUP);

  function moveRun(run: RunToMove) {
    if (!groupName) {
      throw new RangeError(`Called bulk move operation but groupName is null`);
    }

    return moveRunMutation({
      variables: {
        groupName,
        entityName,
        projectName,
        runId: run.id,
      },
    });
  }

  return useAsyncBatcher<RunToMove, unknown>(moveRun, {
    showNavigationAwayWarning: true,
  });
}
